// Templates

// Icons
import userIcon from "../assets/profile.svg";
import createdIcon from "../assets/created.svg";
import GeneralTemplate from "../templates/GeneralTemplate";
import OrderCreated from "../templates/OrdersTemplate";

export const getNotificationType = (notification) => {
  const notificationTypes = new Map();

  notificationTypes.set("user-logged-in", {
    Template: GeneralTemplate,
    data: { icon: userIcon, link: "#" },
  });

  notificationTypes.set("order-created", {
    Template: OrderCreated,
    data: {
      icon: createdIcon,
      link: `/orders/show/${notification?.data?.orderId}`,
    },
  });

  notificationTypes.set("order-shipped", {
    Template: OrderCreated,
    data: {
      icon: createdIcon,
      link: `/orders/show/${notification?.data?.orderId}`,
    },
  });

  return notificationTypes.get(notification?.type);
};
